import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/team?page=1&maxData=99999999' // (17) 팀 조회

let swrData: any = getPersistData(KEY)

export function useTeamList() {
  const { data: token } = useToken()
  const { data, mutate } = useSWR<any>(
    KEY,
    async () => {
      try{
        const response = await API.get(KEY, token + '', {})
        swrData = response.result?.result?.list
      }catch(e){
        swrData = []
      }
      return swrData
    },
    { revalidateOnFocus: true }
  )

  return {
    teamList: data,
    mutate: (value?: any) => {
      if (value != undefined) {
        swrData = value
      }
      return mutate()
    },
  }
}